// i18n/index.ts
import type { I18n } from 'vue-i18n'

let i18n: I18n | null = null

export const setI18n = (instance: I18n) => {
  i18n = instance
}

export const t = (key: string, ...args: any[]) => {
  if (!i18n) {
    console.warn('i18n not initialized yet!')
    return key
  }
  return i18n.global.t(key, ...args)
}
